import midasInstance from '@rsos/midas/src/midasInstance';

export const formatPhoneNumberSlice = phoneNumber => {
  if (
    !phoneNumber ||
    typeof phoneNumber !== 'string' ||
    phoneNumber.length !== 12 ||
    !phoneNumber.startsWith('+1')
  ) {
    return phoneNumber;
  }

  const areaCode = phoneNumber.slice(2, 5);
  const middle = phoneNumber.slice(5, 8);
  const last = phoneNumber.slice(8);

  return `+1 ${areaCode}-${middle}-${last}`;
};

export const callMidasTrigger = async payload => {
  try {
    const response = await midasInstance.post(
      '/internal_auth/trigger',
      payload,
      {
        headers: { retry: true },
      },
    );

    return response?.data ?? null;
  } catch (error) {
    console.error('Error calling Midas: ', error);
    return null;
  }
};
